import { createSlice, createAsyncThunk, createAction } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { getAllDriverResrtvation } from "./driverAxios";

// Get All Driver Reservation
export const GetAllDriverResrtvation = createAsyncThunk(
  "driver/get-all-driver-reservations",
  async (thunkAPI) => {
    try {
      return getAllDriverResrtvation();
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

const initialState = {
  data: [],
  isLoading: false,
  isSuccess: false,
  isError: false,
  destination: "",
  message: "",
  item: false,
  show: false,
};

// Country Slice .............
export const driverSlice = createSlice({
  name: "driver",
  initialState,

  extraReducers: (builder) => {
    builder

      // Get all Status
      .addCase(GetAllDriverResrtvation.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(GetAllDriverResrtvation.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.isError = false;
        state.data = action.payload.data;
      })
      .addCase(GetAllDriverResrtvation.rejected, (state, action) => {
        state.isLoading = false;
        state.isSuccess = false;
        state.isError = true;
        state.message = action.error;
        // toast.error("Loading Faild");
      });
  },
});

export const resetStateDriver = createAction("Reset_all");
export default driverSlice.reducer;
